<template>
    <div v-if="client">
        <!-- track player activity -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Track player activity</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.playerActivity.trackPlayerActivity"
                                type="checkbox"
                            />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- player inactivity timeout -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Player inactivity timeout</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.playerActivity.playerInactivityTimeout"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- player inactivity route -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Player inactivity route</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.playerActivity.playerInactivityRoute"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';

export default {
    name: 'client-settings-view-player-activity',
    components: { ContentStringRef },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/player-activity.vue